import { render, staticRenderFns } from "./TaskInfoModal.vue?vue&type=template&id=8ef66b7c&scoped=true&"
import script from "./TaskInfoModal.vue?vue&type=script&lang=js&"
export * from "./TaskInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./TaskInfoModal.vue?vue&type=style&index=0&id=8ef66b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef66b7c",
  null
  
)

export default component.exports